import { render, staticRenderFns } from "./scroller.vue?vue&type=template&id=ff80036a&scoped=true&"
import script from "./scroller.vue?vue&type=script&lang=js&"
export * from "./scroller.vue?vue&type=script&lang=js&"
import style0 from "./scroller.vue?vue&type=style&index=0&id=ff80036a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff80036a",
  null
  
)

export default component.exports